import React from "react";
import { IActivityTabProps } from "../../interface";
import NoContentComponent from "@/app/components/ui/EmptyStates/NoContent";

const ActivityTab: React.FC<IActivityTabProps> = (_props) => {
  return <NoContentComponent />;
};

export default ActivityTab;
